<template>
  <div class="longterminitform">
    <section class="longterminitform__search">
      <div class="longterminitform__search-fields">
        <div>
          <label>手機</label>
          <div class="longterminitform__search-field">
            <b-form-input v-model="orderUserMobile"></b-form-input>
            <b-button
              @click="searchMobile"
              variant="primary"
              :disabled="!orderUserMobile"
              >搜尋</b-button
            >
          </div>
        </div>
        <div>
          <label>住家電話</label>
          <div class="longterminitform__search-field">
            <b-form-input v-model="orderUserTel"></b-form-input>
            <b-button
              @click="searchTel"
              variant="primary"
              :disabled="!orderUserTel"
              >搜尋</b-button
            >
          </div>
        </div>
        <div>
          <label>姓名</label>
          <div class="longterminitform__search-field">
            <b-form-input v-model="orderUserName"></b-form-input>
            <b-button
              @click="searchName"
              variant="primary"
              :disabled="!orderUserName"
              >搜尋</b-button
            >
          </div>
        </div>
      </div>
      <div
        class="longterminitform__search-result"
        v-if="usersSearchResult.length"
      >
        <b-table
          hover
          selectable
          select-mode="single"
          :fields="orderUserSearchFields"
          :items="usersSearchResult"
        >
          <template #cell(action)="{ item }">
            <b-button
              type="button"
              variant="primary"
              @click="getOrderUserData(item)"
              >選取</b-button
            >
          </template>
        </b-table>
      </div>
      <div
        class="longterminitform__search-result"
        v-if="showOrderUserData && !usersSearchResult.length"
      >
        <FormTitle titleText="乘客資訊" />
        <FormImmutableField
          title="乘客姓名"
          :text="userDetailSearchResult.name"
          class="longterminitform__search-result-field"
        />
        <FormImmutableField
          title="地址"
          :text="userDetailSearchResult.address"
          class="longterminitform__search-result-field"
        />
        <FormImmutableField
          title="自付比例"
          :text="userDetailSearchResult.selfPayRatio"
          class="longterminitform__search-result-field"
        />
        <FormImmutableField
          title="剩餘補助"
          :text="userDetailSearchResult.subsidyLastAmount"
          class="longterminitform__search-result-field"
        />
        <FormImmutableField
          title="社區式剩餘次數"
          :text="userDetailSearchResult.lastCommunityShuttleFrequency"
          class="longterminitform__search-result-field"
        />
      </div>
    </section>

    <b-form class="longterminitform__form">
      <FormTitle titleText="預約資訊" />

      <BaseSelect
        labelText="*派單方式"
        :value="orderData.deliveryMethod"
        :text="deliveryMethodMap(orderData.deliveryMethod)"
        :options="deliveryMethodOptions"
        :required="true"
        @select="orderDataHandler($event, 'deliveryMethod')"
        class="longterminitform__form-field widerlabel"
      />

      <!-- :value="orderData.estimateGetOnTime" -->
      <BaseDateTimePicker
        label="*預定上車時間"
        :required="true"
        :value="orderData.estimateGetOnTime"
        @input="orderDataHandler($event, 'estimateGetOnTime')"
        class="longterminitform__form-field widerlabel"
      />

      <BaseDateTimePicker
        v-if="$route.name !== 'LongTermReservation'"
        label="*實際上車時間"
        :required="true"
        :value="orderData.getOnTime"
        @input="orderDataHandler($event, 'getOnTime')"
        class="longterminitform__form-field widerlabel"
      />

      <BaseDateTimePicker
        v-if="$route.name !== 'LongTermReservation'"
        label="*實際下車時間"
        :required="true"
        :value="orderData.getOffTime"
        @input="orderDataHandler($event, 'getOffTime')"
        class="longterminitform__form-field widerlabel"
      />

      <InputGroupLocation
        :onLocation="orderData.onLocation"
        :orderUserLocation="orderUserLocation"
        :onLocationGps="orderData.onLocationGps"
        :offLocation="orderData.offLocation"
        :offLocationGps="orderData.offLocationGps"
        :userHistoryAddressFields="userHistoryAddressFields"
        :userHistoryAddress="userHistoryAddress"
        @setOnLocation="orderDataHandler($event.value, $event.property)"
        @inputOnLocation="$emit('inputOnLocation', $event)"
        @setOnLocationGps="orderDataHandler($event.value, $event.property)"
        @setOffLocation="orderDataHandler($event.value, $event.property)"
        @inputOffLocation="$emit('inputOffLocation', $event)"
        @setOffLocationGps="orderDataHandler($event.value, $event.property)"
        class="longterminitform__form-field-location"
      >
        <div
          v-if="
            $route.name === 'LongTermReservation' &&
            orderData.onLocation &&
            orderData.offLocation
          "
          slot="addition-content"
          class="longterminitform__form-field-exchange"
        >
          <b-button variant="primary" @click="$emit('locationExchange')"
            ><ExchangeIcon class="mr-3" />上下車地點交換</b-button
          >
        </div>
      </InputGroupLocation>

      <BaseInput
        :value="orderData.seat"
        labelText="乘客數"
        @input="orderDataHandler($event, 'seat')"
        class="longterminitform__form-field widerlabel"
      />

      <BaseCheckGroup
        labelText="偏好服務"
        :checked="orderData.service"
        :options="serviceOptions"
        @change="orderDataHandler($event, 'service')"
        class="longterminitform__form-field widerlabel"
      />

      <BaseTextarea
        labelText="客服備註"
        :value="orderData.serviceNote"
        :isDisabled="false"
        @input="orderDataHandler($event, 'serviceNote')"
        class="longterminitform__form-field widerlabel"
      />

      <InputGroupDriver
        :driver="selectedDriver"
        :licenseNumber="orderData.licenseNumber"
        :driverSearchResult="orderDriverIDSearchResult"
        :licenseNumberSearchResult="orderLicenseNumberSearchResult"
        :required="driverIsRequired"
        @searchDriverId="searchDriverId"
        @selectDriverId="selectDriverId"
        @searchLicenseNumber="searchLicenseNumber"
        @selectLicenseNumber="selectLicenseNumber"
        class="widerlabel"
      />

      <slot name="addition"></slot>

      <BaseButtonGroup
        positiveText="確認"
        negativeText="取消"
        @positive="onSubmit"
        @negative="onReset"
        class="longterminitform__form-button-group"
      />
    </b-form>
  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';
import BaseTextarea from '@/components/base/BaseTextarea';
import BaseSelect from '@/components/base/BaseSelect';
import BaseCheckGroup from '@/components/base/BaseCheckGroup';
import BaseButtonGroup from '@/components/base/BaseButtonGroup';
import BaseDateTimePicker from '@/components/base/BaseDateTimePicker';
import FormTitle from '@/components/commen/FormTitle';
import FormImmutableField from '@/components/commen/FormImmutableField';
import InputGroupDriver from '@/components/commen/InputGroupDriver';
import InputGroupLocation from '@/components/commen/InputGroupLocation';
import ExchangeIcon from '@/assets/images/exchange.svg';

import { mapGetters, mapActions } from 'vuex';
import { deliveryMethodFormMap } from '@/utils/optionMaps';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'LongTermInitForm',
  components: {
    BaseButtonGroup,
    BaseInput,
    BaseTextarea,
    BaseSelect,
    BaseCheckGroup,
    BaseDateTimePicker,
    FormTitle,
    FormImmutableField,
    InputGroupDriver,
    InputGroupLocation,
    ExchangeIcon
  },
  data() {
    return {
      orderUserMobile: '',
      orderUserTel: '',
      orderUserName: '',
      orderUserSearchFields: [
        {
          key: 'id',
          label: '編號'
        },
        {
          key: 'name',
          label: '姓名'
        },
        {
          key: 'address',
          label: '地址'
        },
        {
          key: 'action',
          label: '動作'
        }
      ],
      showOrderUserData: false,
      getOnDate: '',
      getOnTime: '',
      items: [],
      selectedDriver: ''
    };
  },
  props: {
    deliveryMethodOptions: {
      type: Array,
      required: true
    },
    serviceOptions: {
      type: Array,
      required: true
    },
    orderData: {
      type: Object,
      required: true
    },
    usersSearchResult: {
      type: Array,
      default: () => []
    },
    userDetailSearchResult: {
      type: Object,
      required: true
    },
    orderUserLocation: {
      type: Object,
      required: true
    },
    userHistoryAddress: {
      type: Array,
      default: () => []
    },
    orderDriverIDSearchResult: {
      type: Array,
      default: () => []
    },
    orderLicenseNumberSearchResult: {
      type: Array,
      default: () => []
    },
    driverIsRequired: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      fetchUserSearch: 'longTerm/fetchUserSearch'
    }),
    async searchMobile() {
      try {
        await this.fetchUserSearch({
          mobile_phone: this.orderUserMobile
        });
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    async searchTel() {
      try {
        await this.fetchUserSearch({
          telephone: this.orderUserTel
        });
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    async searchName() {
      try {
        await this.fetchUserSearch({
          name: this.orderUserName
        });
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    orderDataHandler(value, property) {
      // console.log(value, property);
      this.$emit('orderDataHandler', {
        value,
        property
      });
    },
    resetSearchData() {
      this.orderUserMobile = '';
      this.orderUserTel = '';
      this.orderUserName = '';
    },
    getOrderUserData(user) {
      this.$emit('getUserOrderData', user);
      this.orderDataHandler(user.id, 'longTermCareUserId');
      this.resetSearchData();
      this.showOrderUserData = true;
    },
    deliveryMethodMap(value) {
      return deliveryMethodFormMap(value);
    },
    searchDriverId(value) {
      this.orderDataHandler(Number(value), 'driverId');
      this.$emit('searchDriverId', value);
    },
    searchLicenseNumber(value) {
      this.orderDataHandler(value, 'licenseNumber');
      this.$emit('searchLicenseNumber', value);
    },
    selectDriverId(item) {
      this.selectedDriver = item.value;
      this.$emit('selectDriverId', item);
    },
    selectLicenseNumber(item) {
      // this.selectedDriver = item.callNumber + '-' + item.name;
      this.$emit('selectLicenseNumber', item);
    },
    onSubmit() {
      this.$emit('onSubmit');
    },
    onReset() {
      this.$emit('onReset');
    }
  },
  computed: {
    ...mapGetters({
      userHistoryAddressFields: 'longTerm/userHistoryAddressFields'
    })
  }
};
</script>

<style lang="scss" scoped>
.longterminitform {
  &__search {
    padding: 20px 20px;
    border: 2px solid $border-gentle;
    margin-bottom: 20px;

    &-fields {
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
    }

    &-result {
      button {
        width: 100px;
      }
      &-field {
        padding: 8px 80px;
        border-bottom: 1px solid $border-light;
        font-size: 12px;
      }
    }

    &-field {
      display: flex;
      input {
        margin-right: 10px;
        width: auto;
      }
      button {
        font-size: 13px;
      }
    }
  }

  &__form {
    padding: 20px 20px;
    border: 2px solid $border-gentle;
    margin-bottom: 20px;

    &-field {
      padding: 20px 80px;
      border-bottom: 1px solid $border-light;

      &:hover {
        background-color: #fafafa;
      }

      label {
        flex: 0 0 100px;
        margin-bottom: 0;
      }

      &-location {
        border-bottom: 1px solid $border-light;
      }

      &-exchange {
        padding: 5px 80px;
        button {
          width: 100%;
        }
      }
    }

    &-button-group {
      margin-top: 50px;
    }
  }

  .form-control,
  .custom-select {
    font-size: 13px;
  }

  .b-form-btn-label-control.form-control {
    width: 200px;
  }
}
</style>
